/*
 * Sinh tự động từ /api/quiz/schema — sửa tay là CI đỏ.
 * Sinh lại bằng: python3 bin/q3_sinh_bo_de.py
 */
window.__msBoDeSnapshot = {
  "gender": null,
  "multi": [
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "M-A",
      "kind": "multi",
      "max_select": 3,
      "min_select": 0,
      "options": [
        {
          "label": "I keep the house, appointments, paperwork and small things from falling through",
          "ord": 0,
          "stable_key": "i-keep-the-house-appointments-paperwork-and-small-things-from-falling-through"
        },
        {
          "label": "I am caring for or worrying about a loved one more than others see",
          "ord": 1,
          "stable_key": "i-am-caring-for-or-worrying-about-a-loved-one-more-than-others-see"
        },
        {
          "label": "My children are grown, but my heart has not fully rested",
          "ord": 2,
          "stable_key": "my-children-are-grown-but-my-heart-has-not-fully-rested"
        },
        {
          "label": "I am beside someone, but often still have to handle things alone",
          "ord": 3,
          "stable_key": "i-am-beside-someone-but-often-still-have-to-handle-things-alone"
        },
        {
          "label": "My work takes more from me than it gives back",
          "ord": 4,
          "stable_key": "my-work-takes-more-from-me-than-it-gives-back"
        },
        {
          "label": "Money or the future makes it hard to relax",
          "ord": 5,
          "stable_key": "money-or-the-future-makes-it-hard-to-relax"
        },
        {
          "label": "A loss or closed chapter is still sitting in my heart",
          "ord": 6,
          "stable_key": "a-loss-or-closed-chapter-is-still-sitting-in-my-heart"
        },
        {
          "label": "My body has changed, and I do not trust it the way I used to",
          "ord": 7,
          "stable_key": "my-body-has-changed-and-i-do-not-trust-it-the-way-i-used-to"
        },
        {
          "label": "No single thing, I just feel myself running down",
          "ord": 8,
          "stable_key": "no-single-thing-i-just-feel-myself-running-down"
        }
      ],
      "ord": 21,
      "positive": null,
      "text": "Right now, which part of life is taking the most from you while almost no one sees it?",
      "tier": null
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "M-C",
      "kind": "multi",
      "max_select": 2,
      "min_select": 0,
      "options": [
        {
          "label": "A rest I do not have to feel guilty about",
          "ord": 0,
          "stable_key": "a-rest-i-do-not-have-to-feel-guilty-about"
        },
        {
          "label": "Someone asking how I am and actually waiting to hear",
          "ord": 1,
          "stable_key": "someone-asking-how-i-am-and-actually-waiting-to-hear"
        },
        {
          "label": "A specific thank-you for what I quietly do",
          "ord": 2,
          "stable_key": "a-specific-thank-you-for-what-i-quietly-do"
        },
        {
          "label": "A no I can say without it becoming a big thing",
          "ord": 3,
          "stable_key": "a-no-i-can-say-without-it-becoming-a-big-thing"
        },
        {
          "label": "A piece of time with my name on it",
          "ord": 4,
          "stable_key": "a-piece-of-time-with-my-name-on-it"
        },
        {
          "label": "A small joy that does not have to be useful",
          "ord": 5,
          "stable_key": "a-small-joy-that-does-not-have-to-be-useful"
        },
        {
          "label": "Peace inside my own home",
          "ord": 6,
          "stable_key": "peace-inside-my-own-home"
        },
        {
          "label": "A sign that the next chapter is still worth looking forward to",
          "ord": 7,
          "stable_key": "a-sign-that-the-next-chapter-is-still-worth-looking-forward-to"
        },
        {
          "label": "A way to care for myself that does not become another task",
          "ord": 8,
          "stable_key": "a-way-to-care-for-myself-that-does-not-become-another-task"
        }
      ],
      "ord": 22,
      "positive": null,
      "text": "If one thing could be returned to you in the next 7 days, what would you want most?",
      "tier": null
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "M-B",
      "kind": "multi",
      "max_select": 3,
      "min_select": 0,
      "options": [
        {
          "label": "I wish someone would notice I am tired without making me explain it.",
          "ord": 0,
          "stable_key": "i-wish-someone-would-notice-i-am-tired-without-making-me-explain-it"
        },
        {
          "label": "It hurts that what I do is treated as obvious.",
          "ord": 1,
          "stable_key": "it-hurts-that-what-i-do-is-treated-as-obvious"
        },
        {
          "label": "I get angry, then feel guilty for being angry.",
          "ord": 2,
          "stable_key": "i-get-angry-then-feel-guilty-for-being-angry"
        },
        {
          "label": "I am scared that if I stop, everything will fall apart.",
          "ord": 3,
          "stable_key": "i-am-scared-that-if-i-stop-everything-will-fall-apart"
        },
        {
          "label": "I miss a lighter, more joyful version of myself.",
          "ord": 4,
          "stable_key": "i-miss-a-lighter-more-joyful-version-of-myself"
        },
        {
          "label": "I have sentences I have rehearsed many times and still not said.",
          "ord": 5,
          "stable_key": "i-have-sentences-i-have-rehearsed-many-times-and-still-not-said"
        },
        {
          "label": "I am afraid that even if I tell the truth, nothing will change.",
          "ord": 6,
          "stable_key": "i-am-afraid-that-even-if-i-tell-the-truth-nothing-will-change"
        },
        {
          "label": "I do not want to be strong for one more day.",
          "ord": 7,
          "stable_key": "i-do-not-want-to-be-strong-for-one-more-day"
        },
        {
          "label": "I do not know what I want anymore.",
          "ord": 8,
          "stable_key": "i-do-not-know-what-i-want-anymore"
        }
      ],
      "ord": 23,
      "positive": null,
      "text": "Is there a sentence you have not said lately, but it keeps sitting in your body?",
      "tier": null
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "fear",
      "kind": "multi",
      "max_select": 2,
      "min_select": 0,
      "options": [
        {
          "label": "Restful sleep",
          "ord": 0,
          "stable_key": "restful-sleep"
        },
        {
          "label": "My own voice",
          "ord": 1,
          "stable_key": "my-own-voice"
        },
        {
          "label": "Small joys",
          "ord": 2,
          "stable_key": "small-joys"
        },
        {
          "label": "The sense that I am still my own person",
          "ord": 3,
          "stable_key": "the-sense-that-i-am-still-my-own-person"
        },
        {
          "label": "Being able to take help without feeling guilty",
          "ord": 4,
          "stable_key": "being-able-to-take-help-without-feeling-guilty"
        }
      ],
      "ord": 24,
      "positive": null,
      "text": "If nothing changed this year, what would you most hate to lose?",
      "tier": null
    }
  ],
  "qc": null,
  "questions": [
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q16",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 0,
      "positive": false,
      "text": "My head keeps running through unfinished things even when my body wants to rest.",
      "tier": "mind"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q1",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 1,
      "positive": true,
      "text": "I wake up feeling my body has recovered enough to step into the day.",
      "tier": "ground"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q2",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 2,
      "positive": false,
      "text": "Money or uncertainty worries me even when things are still technically okay.",
      "tier": "ground"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q3",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 3,
      "positive": false,
      "text": "I often feel restless, as if one more unexpected thing would tip me over.",
      "tier": "ground"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q4",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 4,
      "positive": true,
      "text": "I let myself enjoy small pleasures without feeling guilty or wasteful.",
      "tier": "joy"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q5",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 5,
      "positive": true,
      "text": "Lately I still have moments where I laugh in a real, easy way.",
      "tier": "joy"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q6",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 6,
      "positive": false,
      "text": "I feel dry inside, as if joy needs an appointment before it can enter my day.",
      "tier": "joy"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q7",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 7,
      "positive": false,
      "text": "I often say yes or take on more while something inside me wants to say no.",
      "tier": "line"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q8",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 8,
      "positive": true,
      "text": "Most days I keep at least fifteen minutes that truly belong to me.",
      "tier": "line"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q9",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 9,
      "positive": false,
      "text": "I blame myself heavily whenever the result is not what I hoped for.",
      "tier": "line"
    },
    {
      "dir": "give",
      "exclusive_opt": null,
      "id": "Q10",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 10,
      "positive": true,
      "text": "Putting other people first often leaves very little strength for myself.",
      "tier": "heart"
    },
    {
      "dir": "receive",
      "exclusive_opt": null,
      "id": "Q11",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 11,
      "positive": true,
      "text": "Someone asks how I am and actually waits for the answer, not just as small talk.",
      "tier": "heart"
    },
    {
      "dir": "receive",
      "exclusive_opt": null,
      "id": "Q12",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 12,
      "positive": true,
      "text": "People see and appreciate the quiet things I carry.",
      "tier": "heart"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q13",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 13,
      "positive": false,
      "text": "I swallow my words or hold back my thoughts just to keep the peace.",
      "tier": "voice"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q14",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 14,
      "positive": true,
      "text": "When something matters to me, I can say it and feel genuinely heard.",
      "tier": "voice"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q15",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 15,
      "positive": false,
      "text": "I have to read another person’s mood very carefully before I dare to speak.",
      "tier": "voice"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q17",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 16,
      "positive": true,
      "text": "I trust my intuition and can tell fear apart from a real inner signal.",
      "tier": "mind"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q18",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 17,
      "positive": false,
      "text": "I analyze too many possible scenarios and then struggle to make a clear decision.",
      "tier": "mind"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q19",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 18,
      "positive": true,
      "text": "I still recognize my own value outside the roles and responsibilities I carry.",
      "tier": "meaning"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q20",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 19,
      "positive": true,
      "text": "There is a plan or small hope ahead that belongs just to me.",
      "tier": "meaning"
    },
    {
      "dir": null,
      "exclusive_opt": null,
      "id": "Q21",
      "kind": "single",
      "max_select": null,
      "min_select": null,
      "options": [
        {
          "label": "Not true",
          "ord": 0,
          "stable_key": "not-true"
        },
        {
          "label": "Slightly true",
          "ord": 1,
          "stable_key": "slightly-true"
        },
        {
          "label": "Sometimes true",
          "ord": 2,
          "stable_key": "sometimes-true"
        },
        {
          "label": "Quite true",
          "ord": 3,
          "stable_key": "quite-true"
        },
        {
          "label": "Very true",
          "ord": 4,
          "stable_key": "very-true"
        }
      ],
      "ord": 20,
      "positive": false,
      "text": "Sometimes I feel empty and wonder what all this effort is really for.",
      "tier": "meaning"
    }
  ],
  "version": "v4",
  "wake": null
};
